module.exports = __webpack_public_path__ + "img/ciara-tobin.a6dee0e3.jpg";